import React from 'react';
import { Container, Typography } from '../UI';

const Page404 = () => {
  return (
    <Container>
      <Typography tagName="h3" center="true">
        Page not found
      </Typography>
    </Container>
  );
};

export default Page404;
